import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {environment} from '../../environments/environment';
import {Observable} from 'rxjs';
import {map} from 'rxjs/operators';
import {Certificate, CertificateDto, CertificateType, TestCertificateData} from '../model/contest/Certificate';

@Injectable({
  providedIn: 'root'
})
export class CertificateService {

  private static CONTEST_ID = 'CONTEST_ID';
  private static USER_ID = 'USER_ID';
  private static TYPE = 'TYPE';

  private static CERTIFICATE_BASE_URL = `/contests/${CertificateService.CONTEST_ID}/certificates`;

  private static CERTIFICATE_DETAILS_URL = `${CertificateService.CERTIFICATE_BASE_URL}/${CertificateService.TYPE}`;
  private static CERTIFICATE_TEST_URL = `${CertificateService.CERTIFICATE_DETAILS_URL}/test`;

  private static CERTIFICATE_REQUEST_URL = `${CertificateService.CERTIFICATE_BASE_URL}/users/${CertificateService.USER_ID}`;

  constructor(private http: HttpClient) {
  }

  getCertificate(contestId: string, type: CertificateType): Observable<Certificate> {
    const url = CertificateService.CERTIFICATE_DETAILS_URL
      .replace(CertificateService.CONTEST_ID, contestId)
      .replace(CertificateService.TYPE, type);

    return this.http.get(`${environment.api.host}${url}`)
      .pipe(
        map(data => Certificate.parse(data as CertificateDto))
      );
  }

  saveCertificate(contestId: string, type: CertificateType, certificate: CertificateDto): Observable<Certificate> {
    const url = CertificateService.CERTIFICATE_DETAILS_URL
      .replace(CertificateService.CONTEST_ID, contestId)
      .replace(CertificateService.TYPE, type);

    return this.http.post(`${environment.api.host}${url}`, certificate)
      .pipe(
        map(data => Certificate.parse(data as CertificateDto))
      );
  }

  deleteCertificate(contestId: string, type: CertificateType): Observable<object> {
    const url = CertificateService.CERTIFICATE_DETAILS_URL
      .replace(CertificateService.CONTEST_ID, contestId)
      .replace(CertificateService.TYPE, type);

    return this.http.delete(`${environment.api.host}${url}`);
  }

  testCertificate(contestId: string, type: CertificateType, data: TestCertificateData): Observable<Certificate> {
    const url = CertificateService.CERTIFICATE_TEST_URL
      .replace(CertificateService.CONTEST_ID, contestId)
      .replace(CertificateService.TYPE, type);

    return this.http.post(`${environment.api.host}${url}`, data)
      .pipe(
        map(data => Certificate.parse(data as CertificateDto))
      );
  }

  requestCertificate(contestId: string, userId: string, type?: CertificateType): Observable<Certificate> {
    let url = CertificateService.CERTIFICATE_REQUEST_URL
      .replace(CertificateService.CONTEST_ID, contestId)
      .replace(CertificateService.USER_ID, userId);
    if (type) url += `?type=${type}`;

    return this.http.get(`${environment.api.host}${url}`)
      .pipe(
        map(data => Certificate.parse(data as CertificateDto))
      );
  }

}
